// Утилиты для Яндекс.Метрики.
// Счётчик вставляется в public/index.html (id 98550756).
// Здесь — функции для отслеживания SPA-навигации и целей.

export const METRIKA_ID = 98550756;

// Отправка hit при смене страницы в SPA (BrowserRouter не делает это автоматически).
export const trackPageView = (url) => {
  if (typeof window === "undefined" || !window.ym) return;
  try {
    window.ym(METRIKA_ID, "hit", url || window.location.href, {
      title: document.title,
      referer: document.referrer,
    });
  } catch (e) {
    // молча игнорируем — Метрика могла не успеть загрузиться
  }
};

// Достижение цели в Метрике. Цели создаются в кабинете Метрики как JavaScript-события.
// Используемые цели:
//  - lead_submit          — отправка любой формы (общая конверсия)
//  - lead_<source>        — отправка с конкретной страницы (lead_homepage, lead_crm, ...)
//  - phone_click          — клик по телефону (tel:)
//  - telegram_click       — переход в Telegram
//  - whatsapp_click       — переход в WhatsApp
export const trackGoal = (name, params) => {
  if (typeof window === "undefined" || !window.ym || !name) return;
  try {
    if (params) {
      window.ym(METRIKA_ID, "reachGoal", name, params);
    } else {
      window.ym(METRIKA_ID, "reachGoal", name);
    }
  } catch (e) {
    // ignore
  }
};
